export default "__VITE_ASSET___Ls3HJ5V__"